// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { brokeredPreviewStorage } from './previewAuthStorage';

const SUPABASE_URL = "https://smoeiokykejsjaxkzivt.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InNtb2Vpb2t5a2Vqc2pheGt6aXZ0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDg5MTc0NjcsImV4cCI6MjA2NDQ5MzQ2N30.StoYYMVzUeC5HDPjfQh5LrFuKBFY4Xoyn5nmPz3SMJI";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: brokeredPreviewStorage(),
    persistSession: true,
    autoRefreshToken: true,
  }
});